import { IconDashboard, IconDeviceAnalytics, IconMessages } from '@tabler/icons';
// import { campaignStatuses } from 'constants/statuses';

const icons = { IconDashboard, IconDeviceAnalytics, IconMessages };

const campaigns = (campaignItems) => {
  // TODO: fix filtering
  const pendingCampaigns = [
    ...campaignItems
      // .filter((el) => el.status === campaignStatuses.CAMPAIGN_CREATED)
      .map(({ id, name }) => {
        return {
          id,
          title: name,
          type: 'item',
          url: `/campaign/${id}`,
          breadcrumbs: false
        };
      })
  ];

  if (campaignItems.length > 4) {
    pendingCampaigns.push({
      id: 'outline-chip-menu',
      title: 'SHOW ALL',
      type: 'item',
      url: '/campaigns',
      button: {
        variant: 'outlined',
        color: 'primary'
      }
    });
  }

  const activeCampaigns = [];
  const completedCampaigns = [];
  // const activeCampaigns = campaignItems
  //   .filter((el) => el.status !== campaignStatuses.CAMPAIGN_CREATED)
  //   .map(({ id, name }) => {
  //     return { id, title: name, type: 'item', url: `/campaign/${id}`, breadcrumbs: false };
  //   });
  // const completedCampaigns = campaignItems
  //   .filter((el) => el.status === campaignStatuses.PRODUCTION_IN_PROGRESS)
  //   .map(({ id, name }) => {
  //     return { id, title: name, type: 'item', url: `/campaign/${id}`, breadcrumbs: false };
  //   });

  return {
    id: 'campaigns-list',
    title: 'Campaigns',
    type: 'item',
    icon: icons.IconDeviceAnalytics,
    url: '/campaigns',
    breadcrumbs: false
  };
};

export default campaigns;
